<template>
  <div class="text-center">
    <div class="d-flex justify-content-between justify-content-lg-center">
      <h6 :class="{ 'text-orchid': selected }">
        {{ paymentOptionNames(plan.chargeInterval) }} <span v-if="current">(Current)</span>
      </h6>
      <SequinTag
        v-if="(savings > 0) && isTabletOrSmaller"
        variant="primary"
        class="saving-tag">
        Save {{ formatPrice(savings, false) }}
      </SequinTag>
    </div>
    <div
      class="payment-option-button adorn-border-radius d-flex flex-column justify-content-center p-md"
      :class="{ 'selected': selected }"
      @click="onSelected()">
      <h5 class="text-plum m-0">
        {{ formatPrice(perMonthBreakdown, true) }}/month
      </h5>
      <h6
        v-if="plan.chargeInterval > 1"
        class="text-pewter mt-xs">
        {{ formatPrice(plan.basePrice, false) }} every {{ plan.chargeInterval }} months
      </h6>
    </div>
    <SequinTag
      v-if="(savings > 0) && !isTabletOrSmaller"
      variant="primary"
      class="saving-tag">
      Save {{ formatPrice(savings, false) }}
    </SequinTag>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { usePlanSelection } from '@shared/composables/planSelection.js'
import useScreenSize from '@shared/composables/screenSize.js'
import SequinTag from '@/components/global/sequin/SequinTag.vue'

const props = defineProps({
  plan: {
    type: Object,
    required: true
  },
  selectable: {
    type: Boolean,
    default: true
  }
})
const { isTabletOrSmaller } = useScreenSize()

const {
  paymentOptionNames,
  calculatePerMonthBreakdown,
  calculateSavings,
  paymentOptionsByNumItems,
  selectedPlanId,
  currentPlan,
  formatPrice,
  selectMembershipPlan
} = usePlanSelection()

const selected = computed(() => props.plan.id === selectedPlanId.value)
const current = computed(() => currentPlan.value?.id === props.plan.id)
const perMonthBreakdown = computed(() => {
  return calculatePerMonthBreakdown(props.plan)
})

const savings = computed(() => {
  const plansInGroup = paymentOptionsByNumItems(props.plan.nItems)
  return calculateSavings(props.plan, plansInGroup)
})

const emit = defineEmits(['selected'])
function onSelected() {
  if (props.selectable) {
    selectMembershipPlan({ planId: props.plan.id, trackEvent: true })
    emit('selected', props.plan.id)
  }
}
</script>

<style scoped lang="scss">
.payment-option-button {
  border: 1px solid $pewter;
  padding: 12px;
  min-width: 240px;
  cursor: pointer;

  @include media-desktop {
    min-height: 91px;
  }
}

.selected {
  border: 2px solid $orchid;
}

.saving-tag {
  @include media-desktop {
    position: relative;
    top: -10px;
  }
}

.selected {
  border: 2px solid $orchid;
}
</style>